import { render, staticRenderFns } from "./districts.vue?vue&type=template&id=e86817ea&"
import script from "./districts.vue?vue&type=script&lang=js&"
export * from "./districts.vue?vue&type=script&lang=js&"
import style0 from "./districts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports